import { api } from './api';

export interface ExtractionResponse {
  id: number;
  status: 'pending' | 'processing' | 'done' | 'failed';
  originalFileName: string | null;
  extractedJson: string | null;
  errorMessage: string | null;
  createdAt: string;
}

export interface ExtractedFields {
  istZustand: string[];
  staerken: string[];
  schwaechen: string[];
  schwachstellen: string[];
  massnahmen: string[];
  beratungsziele: string[];
  // Freitextfelder (Strings, keine Listen):
  berichtstitel: string;
  geschaeftsgegenstand: string;
  beratungsauftrag: string;
}

export async function uploadDocumentForExtraction(
  reportId: number,
  file: File,
): Promise<{ extractionId: number; status: string }> {
  const formData = new FormData();
  formData.append('file', file);

  const token = localStorage.getItem('auth_token');
  const response = await fetch(`/api/reports/${reportId}/extract-document`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    body: formData,
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || 'Upload fehlgeschlagen');
  }
  return response.json();
}

export async function getExtraction(reportId: number): Promise<ExtractionResponse | null> {
  return api.get<ExtractionResponse | null>(`/api/reports/${reportId}/extraction`);
}

export async function deleteExtraction(reportId: number): Promise<void> {
  await api.delete(`/api/reports/${reportId}/extraction`);
}

export function parseExtractedFields(extractedJson: string): ExtractedFields {
  const empty: ExtractedFields = { istZustand: [], staerken: [], schwaechen: [], schwachstellen: [], massnahmen: [], beratungsziele: [], berichtstitel: '', geschaeftsgegenstand: '', beratungsauftrag: '' };
  let parsed: any;
  try {
    parsed = JSON.parse(extractedJson);
  } catch {
    return empty;
  }
  const arr = (v: any): string[] => (Array.isArray(v) ? v.filter((x) => typeof x === 'string') : []);
  const str = (v: any): string => (typeof v === 'string' ? v : '');
  return {
    istZustand: arr(parsed?.istZustand),
    staerken: arr(parsed?.staerken),
    schwaechen: arr(parsed?.schwaechen),
    schwachstellen: arr(parsed?.schwachstellen),
    massnahmen: arr(parsed?.massnahmen),
    beratungsziele: arr(parsed?.beratungsziele),
    berichtstitel: str(parsed?.berichtstitel),
    geschaeftsgegenstand: str(parsed?.geschaeftsgegenstand),
    beratungsauftrag: str(parsed?.beratungsauftrag),
  };
}
